import axios from 'axios';

import authService from './auth';
import { isRTL } from './language';

export const axiosRequestInterceptor = () => {
	axios.interceptors.request.use(
		(config) => {
			// add ape id and app key to header
			config.headers['APP-ID'] = process.env['REACT_APP_APP_ID'];
			config.headers['APP-KEY'] = process.env['REACT_APP_APP_KEY'];
			config.headers['X-locale'] = isRTL() ? 'ar' : 'en';

			// add base url to request
			if (config.url && !config.url.startsWith('http') && !config.url.startsWith(process.env['REACT_APP_BASE_API_ENDPOINT'] || '')) {
				config.url = process.env['REACT_APP_BASE_API_ENDPOINT'] + config.url;
			}

			const token = authService.token;
			if (token) config.headers['Authorization'] = 'Bearer ' + token;

			return config;
		},
		(error) => {
			return Promise.reject(error);
		},
	);

	axios.interceptors.response.use(
		(response) => {
			return response;
		},
		(error) => {
			// if (!error.request.responseURL.includes('login') && error.status === 401) {
			// 	// authService.clearAuthData();
			// 	NotificationService.error('Unauthorized', 'please re-login again');
			// 	window.history.pushState({}, '', '/login');
			// 	window.dispatchEvent(new PopStateEvent('popstate'));
			// }

			return Promise.reject(error);
		},
	);
};
